<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 16 16" :class="[`${prefix}-icon`, `${prefix}-icon-packUp`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_def9e98b60__a"><rect width="16" height="16" rx="0"/></clipPath></defs><g clip-path="url(#svg_def9e98b60__a)"><path d="M3.466796875,2.833381828125C3.466796875,2.974830828125,3.522987175,3.110486828125,3.623006875,3.210505828125L8.412546875,8.000048828125L3.623265875,12.789348828125L3.623265875,12.789348828125C3.522987175,12.889648828125,3.466796875,13.025248828125,3.466796875,13.166748828125C3.466796875,13.461248828125,3.705577875,13.700048828125,4.000129875,13.700048828125C4.141578875,13.700048828125,4.2772348749999995,13.643848828125,4.377253875,13.543848828125L9.543916875,8.377168828125C9.752196875,8.168888828124999,9.752196875,7.831208828125,9.543916875,7.622928828125L4.377253875,2.456258828125C4.2772348749999995,2.356239128125,4.141578875,2.300048828125,4.000129875,2.300048828125C3.705577875,2.300048828125,3.466796875,2.538829828125,3.466796875,2.833381828125Z" fill-rule="evenodd"/><rect x="11" y="2" width="1" height="12" rx=".5"/></g></svg>
</template>
<script>

export default {
  name: 'IconPackUp',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
